import { ArrowBackOutlined } from '@mui/icons-material';
import styles from './PageHeader.module.css';

export interface PageHeaderProps {
	title: string;
	subtitle: string;
	onBack: () => void;
}

export const PageHeader = ({ title, subtitle, onBack }: PageHeaderProps) => (
	<div className={styles.header}>
		<div className={styles.left}>
			<h1 className={styles.title}>{title}</h1>
			<p className={styles.subtitle}>{subtitle}</p>
		</div>
		<button className={styles.backButton} onClick={onBack}>
			<ArrowBackOutlined className={styles.backIcon} />
			Voltar
		</button>
	</div>
);
